import React from "react";
import { Language } from "./src/components/language";



export const wrapRootElement = ({element}) => {
    return (<Language>{element}</Language>)
}